import {
  IUserPreferenceGeneralListItem,
  IUserPreferenceGeneralListItemType,
  MapViewBaseLayer,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { HereMapBaseView, HereMapDefaultLayers } from './types'

const DEFAULT_MAP_VIEW: HereMapBaseView = 'vector'

export function getPreferredMapBaseView(
  userGeneralPreferences?: IUserPreferenceGeneralListItem[],
): HereMapBaseView {
  const rawValue = userGeneralPreferences?.find(
    (row) => row.type === IUserPreferenceGeneralListItemType.MapViewBaseLayer,
  )?.value

  return isHereMapBaseView(rawValue) ? rawValue : DEFAULT_MAP_VIEW
}

export function applyHereMapBaseView(
  hereMap: H.Map,
  defaultLayers: HereMapDefaultLayers,
  mapView: HereMapBaseView,
) {
  try {
    switch (mapView) {
      case 'satellite':
        hereMap.setBaseLayer(defaultLayers.raster.satellite.base)
        hereMap.addLayer(defaultLayers.hybrid.day.vector)
        break
      case 'terrain':
        removeHybridOverlayIfPresent(hereMap, defaultLayers)
        hereMap.setBaseLayer(defaultLayers.vector.normal.topo)
        break
      case 'vector':
      default:
        removeHybridOverlayIfPresent(hereMap, defaultLayers)
        hereMap.setBaseLayer(defaultLayers.vector.normal.map)
        break
    }
  } catch (error) {
    console.error('[applyHereMapBaseView] Error applying map view:', error)
  }
}

function removeHybridOverlayIfPresent(
  hereMap: H.Map,
  defaultLayers: HereMapDefaultLayers,
) {
  const layers = hereMap.getLayers()

  if (layers.indexOf(defaultLayers.hybrid.day.vector) !== -1) {
    hereMap.removeLayer(defaultLayers.hybrid.day.vector)
  }
}

export function getHereMapBaseLayer(
  defaultLayers: HereMapDefaultLayers,
  mapView: HereMapBaseView,
): H.map.layer.Layer {
  switch (mapView) {
    case 'satellite':
      return defaultLayers.raster.satellite.base
    case 'terrain':
      return defaultLayers.vector.normal.topo
    case 'vector':
    default:
      return defaultLayers.vector.normal.map
  }
}

export function isHereMapBaseView(
  value: string | undefined | null,
): value is MapViewBaseLayer {
  return value === 'vector' || value === 'satellite' || value === 'terrain'
}

// Pin Density (SH-919). Returns undefined when the user has never saved a
// choice, so the caller can leave the existing default (map/slice.ts's
// `collisionDetectionEnabled: true`) in place rather than this helper
// hardcoding a second copy of that same default.
export function getPreferredCollisionDetectionEnabled(
  userGeneralPreferences?: IUserPreferenceGeneralListItem[],
): boolean | undefined {
  const rawValue = userGeneralPreferences?.find(
    (row) =>
      row.type === IUserPreferenceGeneralListItemType.CollisionDetectionEnabled,
  )?.value

  if (rawValue === 'true') return true
  if (rawValue === 'false') return false
  return undefined
}
